module.exports = __webpack_public_path__ + "img/4(2)-192x192-2.d0dfe055.png";